import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const DashboardOpsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/dashboardOps',
      component: FuseLoadable({
        loader: () => import('./DashboardOps')
      })
    }
  ]
}
